import { render, staticRenderFns } from "./ObjectStatusesPicker.vue?vue&type=template&id=2d03409b&lang=pug&"
import script from "./ObjectStatusesPicker.vue?vue&type=script&lang=js&"
export * from "./ObjectStatusesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports